/**
 * @fileoverview Model for a linked account.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

export class LinkedAccount {
  /**
    * @param {{
    *  id: number,
    *  name: string,
    *  emailAddress: string,
    * }} params
    */
  constructor(params) {
    /** @type {number} */
    this.id = params.id;
    /** @type {string} */
    this.name = params.name;
    /** @type {string} */
    this.emailAddress = params.emailAddress;
  }

  /**
   * @returns {!LinkedAccountJson}
   */
  toJSON() {
    return {
      'id': this.id,
      'name': this.name,
      'emailAddress': this.emailAddress,
    };
  }
}

/**
  * @dict
  * @typedef {{
 *  id: number,
 *  name: string,
 *  emailAddress: string,
 * }}
 */
export let LinkedAccountJson;
